import { Options } from 'ky';
import {
  DepExport,
  FailedSignedReceipt,
  InitialReceipt,
  Receipt,
  SettingsData,
} from 'utils/apiClient/services/rksv/types';
import config from 'config';
import { downloadFile } from 'ShorePay/utils';
import { NULL_RECEIPT, MONTHLY_RECEIPT, YEARLY_RECEIPT } from 'RKSV/constants';
import { useAuthenticatedApiClient } from '../../base';

const rskvClientOpts: Options = {
  prefixUrl: '/signat/api/',
};

const customJsonHeader = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const endpointByType: Record<string, string> = {
  [NULL_RECEIPT]: 'receipts/nullbeleg',
  [MONTHLY_RECEIPT]: 'receipts/monthly',
  [YEARLY_RECEIPT]: 'receipts/yearly',
};

/* eslint-disable import/prefer-default-export */
export const useRKSVapi = () => {
  const authenticatedApiClient = useAuthenticatedApiClient();
  const rksvApiClient = authenticatedApiClient.extend(rskvClientOpts);
  return {
    getSettings: () =>
      rksvApiClient
        .get('settings', {
          headers: customJsonHeader,
        })
        .json<SettingsData>(),
    postSettings: (
      settingsData: Pick<SettingsData, 'cashboxId' | 'token' | 'terminalId'>
    ) =>
      rksvApiClient.post('settings', {
        headers: customJsonHeader,
        body: JSON.stringify(settingsData),
      }),
    resetSettings: () =>
      rksvApiClient.delete(`settings`, {
        headers: customJsonHeader,
      }),
    getAllReceipts: () =>
      rksvApiClient
        .get('receipts', {
          headers: customJsonHeader,
        })
        .json<Array<Receipt>>(),
    getFailedReceipts: () =>
      rksvApiClient
        .get('receipts/failed', {
          headers: customJsonHeader,
        })
        .json<Array<Receipt>>(),
    signFailedReceipts: () =>
      rksvApiClient
        .post('receipts/failed/sign', {
          headers: customJsonHeader,
          body: null,
        })
        .json<FailedSignedReceipt>(),
    generateInitalReceipt: () =>
      rksvApiClient.post('receipts/initialize', {
        headers: customJsonHeader,
        body: null,
      }),
    getInitalReceipt: () =>
      rksvApiClient
        .get('receipts/initial', {
          headers: customJsonHeader,
        })
        .json<InitialReceipt>(),
    loadDepExport: ({ from, to }: { from: string; to: string }) =>
      rksvApiClient
        .post('receipts/journal', {
          headers: customJsonHeader,
          body: JSON.stringify({ from, to }),
        })
        .json<DepExport>(),
    downloadReceipt: async ({
      orderId,
      fileName,
      fileFormat,
    }: {
      orderId: number;
      fileName: string;
      fileFormat: string;
    }) => {
      const fileUrls: any = await authenticatedApiClient
        .get(`${config.CORE_URL}/api/orders/${orderId}/receipt/`)
        .json();
      const fileUrl =
        fileFormat === 'application/pdf'
          ? fileUrls.presigned_pdf_url
          : fileUrls.presigned_image_url;
      const ext = fileFormat === 'application/pdf' ? '.pdf' : '.png';
      downloadFile(fileUrl, `r-${fileName}${ext}`, true);
    },
    postCustomReceipt: ({ receiptType }: { receiptType: string }) =>
      rksvApiClient.post(endpointByType[receiptType], {
        body: null,
        headers: customJsonHeader,
      }),
  };
};
